package com.neurobs.ccab.translation

import io.circe.Json


case class CCABTestPhrase(
  phrase: String,
  test: String,
  translation: Option[String],
  data: Json
                         ) {

}

object CCABTestFile {

  def processTranslations(testPhrases: List[CCABTestPhrase], translatedPhrases: List[OrderedTranslationPhraseData]) = {
    var processedTestPhrases = List[CCABTestPhrase]()
    testPhrases.foreach(testPhrase => {
      translatedPhrases.find(_.text == testPhrase.phrase) match {
        case None =>
          processedTestPhrases = processedTestPhrases :+ testPhrase
        case Some(translatedPhrase) => translatedPhrase.translationText match {
          case None =>
            processedTestPhrases = processedTestPhrases :+ testPhrase
          case Some(translatedText) =>
            val translatedTestPhrase = testPhrase.copy(translation = Some(translatedText))
            processedTestPhrases = processedTestPhrases :+ translatedTestPhrase
        }
      }
    })
    processedTestPhrases
  }


}